import integration from 'services/integration';
import { isRoobetHost } from '../../hostsConfig';

function Footer() {
  const logoSrc = isRoobetHost ? '/roobet-logo.svg' : '/logo-large.svg'
  const onClick = (path) => {
    if (path) {
      integration.emit({ path }, 'iframe-navigation');
    }
  };

  return (
    <footer className={`${isRoobetHost ? 'roobet' : ''}`}>
      <div class="footer-container">
        <div class="footer-column">
          <h3>About Us</h3>
          <p>
            We are committed to delivering the best services and creating
            meaningful digital experiences for our clients.
          </p>
        </div>
        <div className="footer-column">
          <h3>Quick Links</h3>
          <ul>
            <li>
              <a href="#about">About</a>
            </li>
            <li>
              <a href="#services">Services</a>
            </li>
            <li>
              <a href="#contact">Contact</a>
            </li>
            <li>
              <a href="#faq">FAQ</a>
            </li>
          </ul>
        </div>
        <div className="footer-column">
          <h3>Sports</h3>
          <ul>
            <li>
              <a
                href="/all-live"
                onClick={(e) => {
                  e.preventDefault();
                  onClick('/all-live');
                }}
              >
                  All live
                </a>
            </li>
            <li>
              <a
                href="/football/live"
                onClick={(e) => {
                  e.preventDefault();
                  onClick('/football/live');
                }}
              >
                Football
              </a>
            </li>
            <li>
              <a
                href="/basketball"
                onClick={(e) => {
                  e.preventDefault();
                  onClick('/basketball/live');
                }}
              >
                  Basketball
              </a>
            </li>
            <li>
              <a
                href="/top-express"
                onClick={(e) => {
                  e.preventDefault();
                  onClick('/top-express');
                }}
              >
                Top Express
              </a>
            </li>
          </ul>
        </div>
        <div className="footer-logo">
          <img src={ logoSrc } width="113" height="28" alt="Website Logo" className="logo" />
          <p>&copy; 2025 {!isRoobetHost && <span>GR8 Tech. </span>}All rights reserved.</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer;